import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerSW } from "virtual:pwa-register";
import { initSentry } from "./lib/sentry";

// Initialize Sentry for error tracking (before anything else)
initSentry();

// Register Service Worker for PWA support
registerSW({ immediate: true });

createRoot(document.getElementById("root")!).render(<App />);
